/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import Reveal from "./Reveal";
import { SHOWCASE_SHOTS } from "../showcase/showcase.data";

export default function ProductShowcase({ isArabic }) {
  const shots = SHOWCASE_SHOTS.slice(0, 3);

  return (
    <section className="gl-section" id="product">
      <div className="gl-shell">
        <Reveal className="gl-head">
          <p className="gl-eyebrow">
            {isArabic ? "المنتج" : "Product"}
          </p>
          <h2 className="gl-title">
            {isArabic
              ? "لوحة تحكم كأنها من المستقبل"
              : "A control center from the future"}
          </h2>
          <p className="gl-lead">
            {isArabic
              ? "شاهد كيف تبدو إدارة المبيعات والمنتجات والطلبات داخل مدار."
              : "See how sales, products, and orders feel inside Madar."}
          </p>
        </Reveal>

        <div className="gl-showcase">
          {shots.map((shot, i) => (
            <Reveal
              key={shot.id}
              delay={i * 0.08}
              className={`gl-shot${i === 0 ? " gl-shot--hero" : ""}`}
            >
              <img
                src={shot.src}
                alt={isArabic ? shot.titleAr : shot.titleEn}
                loading="lazy"
              />
              <div className="gl-shot__cap">
                <h3>{isArabic ? shot.titleAr : shot.titleEn}</h3>
                <p>{isArabic ? shot.descAr : shot.descEn}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
